<template>
  <div
    class="tooltip-situacao-wrapper"
    @mouseenter="abrirTooltip"
    @mouseleave="agendarFechar"
  >
    <slot />
    <teleport-fix>
      <div
        v-if="show"
        class="tooltip-situacao-popup"
        :style="popupStyle"
        @mouseenter="cancelarFechar"
        @mouseleave="agendarFechar"
      >
        <div class="tooltip-situacao-header">
          <span>ROTINA</span>
          <span>STATUS</span>
        </div>
        <div class="tooltip-situacao-body">
          <div
            v-for="rotina in rotinasSorted"
            :key="rotina.field"
            class="tooltip-situacao-row"
          >
            <span class="tooltip-rotina-label">{{ rotina.label }}</span>
            <b-badge
              v-if="rotina.valor === 'regular'"
              variant="light-success"
            >
              Regular
            </b-badge>
            <b-badge
              v-else-if="rotina.valor === 'irregular'"
              variant="light-danger"
            >
              Irregular
            </b-badge>
            <span
              v-else
              class="tooltip-sem-dados"
            >-</span>
          </div>
        </div>
      </div>
    </teleport-fix>
  </div>
</template>

<script>
const POPUP_WIDTH = 240
const POPUP_HEIGHT_APPROX = 320

const ROTINAS = [
  { label: 'Situação fiscal', field: 'situacaoFiscal' },
  { label: 'DCTFWeb', field: 'dctfWeb' },
  { label: 'CND RFB/PGFN', field: 'cndRfbPgft' },
  { label: 'CND FGTS', field: 'cndFgts' },
  { label: 'CND Trabalhista', field: 'cndTrabalhista' },
  { label: 'CND Estadual', field: 'cndEstadual' },
  { label: 'CND Municipal', field: 'cndMunicipal' },
  { label: 'Parcelamento SN', field: 'simplesNacional' },
  { label: 'PERT-SN', field: 'pert' },
  { label: 'RELP-SN', field: 'relp' },
  { label: 'RFB', field: 'rfb' },
  { label: 'Não Previdenciário', field: 'naoPrevidenciario' },
  { label: 'Simpl. Previdenciário', field: 'simplificadoPrevidenciario' },
  { label: 'PGFN', field: 'pgfn' },
  { label: 'Sublimite', field: 'sublimite' },
  { label: 'DAS', field: 'das' },
]

function ordemStatus(valor) {
  if (valor === 'irregular') return 0
  if (valor === 'regular') return 1
  return 2
}

export default {
  name: 'TooltipSituacao',

  components: {
    TeleportFix: {
      render(h) {
        return h('div', { style: 'display:contents' }, this.$slots.default)
      },
      mounted() {
        document.body.appendChild(this.$el)
      },
      destroyed() {
        if (this.$el && this.$el.parentNode) {
          this.$el.parentNode.removeChild(this.$el)
        }
      },
    },
  },

  props: {
    row: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      show: false,
      popupStyle: {},
      hideTimer: null,
    }
  },

  beforeDestroy() {
    this.cancelarFechar()
  },

  computed: {
    rotinasSorted() {
      return ROTINAS
        .map(r => ({ ...r, valor: this.row[r.field] || null }))
        .sort((a, b) => ordemStatus(a.valor) - ordemStatus(b.valor))
    },
  },

  methods: {
    agendarFechar() {
      this.hideTimer = setTimeout(() => { this.show = false }, 120)
    },
    cancelarFechar() {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer)
        this.hideTimer = null
      }
    },
    abrirTooltip() {
      this.cancelarFechar()
      const rect = this.$el.getBoundingClientRect()
      const viewportH = window.innerHeight
      const viewportW = window.innerWidth

      let top = rect.bottom + 4
      let left = rect.left + rect.width / 2 - POPUP_WIDTH / 2

      // inverte para cima se não couber abaixo
      if (top + POPUP_HEIGHT_APPROX > viewportH) {
        top = rect.top - POPUP_HEIGHT_APPROX - 4
      }

      // mantém dentro da janela horizontalmente
      if (left + POPUP_WIDTH > viewportW) {
        left = viewportW - POPUP_WIDTH - 8
      }
      if (left < 8) {
        left = 8
      }

      this.popupStyle = {
        position: 'fixed',
        top: `${top}px`,
        left: `${left}px`,
        width: `${POPUP_WIDTH}px`,
        zIndex: 9999,
      }

      this.show = true
    },
  },
}
</script>

<style>
.tooltip-situacao-popup {
  background: #fff;
  border: 1px solid #000;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.tooltip-situacao-header {
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
  background: #f3f2f7;
  border-bottom: 1px solid #ebe9f1;
  font-weight: 700;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #5e5873;
}

.tooltip-situacao-body {
  max-height: 252px;
  overflow-y: auto;
}

.tooltip-situacao-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  font-size: 0.85rem;
  border-bottom: 1px solid #f3f2f7;
}

.tooltip-situacao-row:last-child {
  border-bottom: none;
}

.tooltip-rotina-label {
  color: #6e6b7b;
  flex: 1;
  margin-right: 8px;
  white-space: nowrap;
}

.tooltip-sem-dados {
  color: #b9b9c3;
  font-size: 0.85rem;
}
</style>

<style scoped>
.tooltip-situacao-wrapper {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  cursor: default;
}
</style>
